var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHelpSvg = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13.233,
    height: 13.233,
    viewBox: "0 0 13.233 13.233",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "np_help_3496194_000000",
    transform: "translate(-0.001 0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5756",
    "data-name": "Path 5756",
    d: "M38.6,63.051a.551.551,0,1,1-1.1,0,.551.551,0,1,1,1.1,0",
    transform: "translate(-32.536 -54.231)",
    fill: "#725d7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5757",
    "data-name": "Path 5757",
    d: "M28.309,18.862a1.1,1.1,0,0,1-1.1,1.1.551.551,0,0,0-.552.551v1.1a.551.551,0,0,0,1.1,0V21A2.205,2.205,0,1,0,25,18.862a.551.551,0,1,0,1.1,0,1.1,1.1,0,0,1,2.206,0Z",
    transform: "translate(-21.691 -14.453)",
    fill: "#725d7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5758",
    "data-name": "Path 5758",
    d: "M13.234,12.679V7.717a5.48,5.48,0,0,0-2.867-4.824A5.513,5.513,0,0,0,0,5.512v4.962a.551.551,0,0,0,.552.551H3.31A5.513,5.513,0,0,0,7.72,13.23h4.962a.551.551,0,0,0,.552-.552ZM1.1,5.512A4.411,4.411,0,1,1,5.515,9.922H1.1Zm11.028,6.616H7.72a4.412,4.412,0,0,1-2.911-1.1h.706a5.475,5.475,0,0,0,5.453-6.274,4.41,4.41,0,0,1,1.164,2.966Z",
    transform: "translate(0 0)",
    fill: "#725d7b"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHelpSvg, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/helpSvg.5e75096c.svg";
export { ForwardRef as ReactComponent };